import State from "../lib/State";

import ServiceLocator from "../ServiceLocator";
import * as PIXI from "pixi.js";
import GameplayScreen from "../screen/GameplayScreen";
import { IGameSnacks } from "../lib/GameSnacks";
import AdManager from "../lib/AdManager";
import Screen from "../lib/Screen";
import LobbyScreen from "../screen/LobbyScreen";
import TweenGroup from "../lib/TweenGroup";
import MultiplayerEventManager, { game_event_type } from "../service/MultiplayerEventManager";
import { IInit, Profile } from "../lib/game_snacks/IUser";
import Session, { game_type } from "../Session";
import { LiveEventData, LiveEventDataType, LivePlayerDataEvent, LivePresenceAction, LiveRoomData } from "../lib/game_snacks/ILiveMultiplayer";
import Utils from "../Utils";
import PrivateRoomPopup from "../screen/popup/HostPrivateRoomPopup";
import GuestPrivateRoomPopup from "../screen/popup/GuestPrivateRoomPopup";
import MessagePopup from "../screen/popup/MessagePopup";
import FakeMatchMakingScreen from "../screen/FakeMatchMakingScreen";
import ShopScreen from "../screen/ShopScreen";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class GameState extends State
{
    // #region Attributes //

    // private:

    private _curScreen: Screen = null; 

    private _arrInvitationEvent: Array<LiveEventData> = null;
    
    private _adManager: AdManager = null;
    private _tweenGroup: TweenGroup = null;

    private _checkPrivateRoomPopup: MessagePopup = null;
    private _checkPrivateRoomTimer: number = null;

    private _state: game_state_type = null;

    private _isReady: boolean = null;

    // #endregion //


    public get ad(): AdManager { return this._adManager; }
    public get tweenGroup(): TweenGroup { return this._tweenGroup; }


    // #region Methods //

    // public:

    public constructor() 
    { 
        super(); 
    }

    public onEnter( params: Object = null ): void
    {
        this._state = game_state_type.IDLE;
        this._isReady = false;

        this._adManager = new AdManager();
        this._adManager.init();

        this._tweenGroup = new TweenGroup();
        this._tweenGroup.init();

        ServiceLocator.multiplayerEventManager = new MultiplayerEventManager();
        ServiceLocator.multiplayerEventManager.onProfileChange.addOnce( ( profile: Profile ) => {
            Session.i.profile = profile;

            if ( Session.i.profile == null && Session.i.isInvite )
            {
                this._state = game_state_type.IDLE;

                ServiceLocator.multiplayerEventManager.onRoomLoaded.removeAll();
                ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.removeAll();
                ServiceLocator.multiplayerEventManager.onEventsReceived.removeAll();
            
                ServiceLocator.app.root.interactiveChildren = true;
            }
        } );
                    
        /*if ( ServiceLocator.saved.data.isFirstGame )
        {
            Session.i.profile = { 
                username: { prefix: "You", suffix: "" },
                avatar: { src: "./resources/img/common/avatar/0.svg", alt: null },
                uid: "fake",
                isFake: true };

            let fakeMatchmakingScreen: FakeMatchMakingScreen = new FakeMatchMakingScreen();
            fakeMatchmakingScreen.onEnter();
            fakeMatchmakingScreen.onCompleted.addOnce( this._onScreen_Completed, this );
            this._curScreen = fakeMatchmakingScreen;

            window.GameSnacks.game.ready();

            this._isReady = true;
        }
        else
        {*/
            this._initMultiplayerAPI();
        //}

        // TEST:
        /*let g = new PIXI.Graphics();
        g.beginFill( 0xffffff );
        g.drawRect( 0, 0, ServiceLocator.app.width, ServiceLocator.app.height );
        g.endFill();
        ServiceLocator.app.stage.addChild( g );

        for ( let i = 0; i < 3; ++i )
        {
            let test = new PIXI.Sprite( ServiceLocator.resources[ [ "test1x", "test2x", "test4x" ][ i ] ].texture );
            test.position.set( 100, 100 + i * 150 );
            ServiceLocator.app.stage.addChild( test );
        }*/

        // TEST:
        ServiceLocator.audio.playMusic( "track_0", { loop: true } );
    }
        
        private _initMultiplayerAPI(): void
        {
            // IMPORTANT: Cannot be done inside the GameSnacks.init() callback, since presence update and room joined events are received before the callback is invoked ??? 
            this._arrInvitationEvent = [];
            ServiceLocator.multiplayerEventManager.onRoomLoaded.add( this._onRoom_Loaded, this );
            ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.add( this._onMultiplayer_PlayerPresenceUpdated, this );
            ServiceLocator.multiplayerEventManager.onEventsReceived.add( this._onMultiplayer_EventsReceived, this );
        
            ServiceLocator.app.root.interactiveChildren = false;
            //
            window.GameSnacks.init()
                .then( ( value: IInit ) => {

                    if ( value.isInvite )
                    {
                        Session.i.isInvite = true;

                        if ( this._state == game_state_type.IDLE )
                        {
                            this._checkPrivateRoomTimer = 0;
                                    
                            this._state = game_state_type.CHECK_PRIVATE_ROOM;
                        }
                    }
                    else
                    {
                        ServiceLocator.multiplayerEventManager.onRoomLoaded.removeAll();
                        ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.removeAll();
                        ServiceLocator.multiplayerEventManager.onEventsReceived.removeAll();
                    }

                    if ( value.isInvite || !ServiceLocator.saved.data.isFirstGame )
                    {
                        if ( value.isInvite )
                        {
                            ServiceLocator.saved.data.isFirstGame = false;
                            ServiceLocator.saved.save();
                        }

                        let lobbyScreen: LobbyScreen = new LobbyScreen();
                        lobbyScreen.onEnter();
                        lobbyScreen.onCompleted.addOnce( this._onScreen_Completed, this );
                        this._curScreen = lobbyScreen;
                    }
                    else
                    {
                        if ( !Session.i.profile )
                        {
                            Session.i.profile = { 
                                username: { prefix: "You", suffix: "" },
                                avatar: { src: "avatar_you", alt: null },
                                uid: "fake",
                                isFake: true };
                        }

                        let fakeMatchmakingScreen: FakeMatchMakingScreen = new FakeMatchMakingScreen();
                        fakeMatchmakingScreen.onEnter();
                        fakeMatchmakingScreen.onCompleted.addOnce( this._onScreen_Completed, this );
                        this._curScreen = fakeMatchmakingScreen;
                    }

                    if ( !Session.i.isInvite )
                    {
                        ServiceLocator.app.root.interactiveChildren = true;
                    }
                    else
                    {
                        this._checkPrivateRoomPopup = Utils.showMessagePopup( "Connecting to private room...", false );
                    }

                    if ( !this._isReady )
                    {
                        this._isReady = true;

                        window.GameSnacks.game.ready();
                    }
                } );
        }

            private _onMultiplayer_PlayerPresenceUpdated( presenceEventPromise: Promise<LivePlayerDataEvent> ): void
            {
                presenceEventPromise
                    .then( ( livePlayerDataEvent: LivePlayerDataEvent ) => {
                        if ( livePlayerDataEvent.action == LivePresenceAction.JOIN )
                        {
                            if ( livePlayerDataEvent.isLocalPlayer )
                            {
                                let profile: Profile = livePlayerDataEvent.profile;
                                profile.uid = livePlayerDataEvent.uid;

                                if ( !Session.i.profile )
                                {
                                    Session.i.profile = profile;
                                }
                                else
                                {
                                    Session.i.profile.uid = profile.uid;
                                }

                                console.log( "_onMultiplayer_PlayerPresenceUpdated :: " + Session.i.room.length );
                            
                                this._checkPrivateRoomTimer = 0;

                                this._state = game_state_type.CHECK_INVITATION_EVENTS;
                            }
                        }
                    } );
            }

            private _onRoom_Loaded( liveRoomData: Promise<LiveRoomData> ): void
            {
                liveRoomData
                    .then( ( liveRoomData: LiveRoomData ) => {
                        Session.i.room = [];
                        for ( let i: number = 0; i < liveRoomData.players.length; ++i )
                        {
                            if ( liveRoomData.players[ i ].action == LivePresenceAction.JOIN )
                            {
                                let profile: Profile = liveRoomData.players[ i ].profile;
                                profile.uid = liveRoomData.players[ i ].uid;
                                Session.i.room.push( profile );
                            }
                        }
                        console.log( "_onRoom_Loaded :: " + Session.i.room.length );
                    } );
            }

            private _onMultiplayer_EventsReceived( eventsPromise: Promise<LiveEventData[]> ): void
            {
                eventsPromise
                    .then( ( arrData: LiveEventData[] ) => {
                        this._arrInvitationEvent.push( ...arrData );
                    } );
            }

                private _onGuestPrivateRoomPopup_Closed( popup: GuestPrivateRoomPopup ): void
                {
                    popup.onLeave();

                    Session.i.room = [];
                }

                private _onGuestPrivateRoomPopup_GameStarted( popup: GuestPrivateRoomPopup, gameType: game_type ): void
                {
                    popup.onLeave();

                    Session.i.gameType = gameType;

                    this._onScreen_Completed( screen_type.GAMEPLAY );
                }

        private _onScreen_Completed( nextScreen: screen_type, params: any = null ): void
        {
            this._curScreen.onLeave();

            if ( ServiceLocator.saved.data.isFirstGame && nextScreen == screen_type.LOBBY )
            {
                ServiceLocator.saved.data.isFirstGame = false;
                ServiceLocator.saved.save();

                if ( Session.i.profile.isFake )
                {
                    Session.i.profile = null;
                }
                Session.i.room = null;
                //this._initMultiplayerAPI();
            }
            
            switch ( nextScreen )
            {
                case screen_type.LOBBY: { this._curScreen = new LobbyScreen(); break; }
                case screen_type.GAMEPLAY: { this._curScreen = new GameplayScreen(); break; }
                case screen_type.FAKE_MATCH_MAKING: { this._curScreen = new FakeMatchMakingScreen(); break; }
                case screen_type.SHOP: { this._curScreen = new ShopScreen(); break; }
            }
            this._curScreen.onEnter( params );
            this._curScreen.onCompleted.addOnce( this._onScreen_Completed, this );
        }

    public onLeave(): void
    {
        this._curScreen.onLeave();
        this._curScreen = null;

        this._adManager.end();
        this._adManager = null;

        this._tweenGroup.end();
        this._tweenGroup = null;
    
        super.onLeave();
    }

    public onUpdate( dt: number ): void
    {
        if ( this._curScreen )
        {
            this._curScreen.onUpdate( dt );
        }

        if ( this._state == game_state_type.CHECK_PRIVATE_ROOM )
        {
            this._checkPrivateRoomTimer += dt;
            if ( this._checkPrivateRoomTimer >= 6 )
            {
                this._checkPrivateRoomPopup.onLeave();
                this._checkPrivateRoomPopup = null;

                Session.i.room = []
                Session.i.isInvite = false;

                ServiceLocator.multiplayerEventManager.onRoomLoaded.removeAll();
                ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.removeAll();
                ServiceLocator.multiplayerEventManager.onEventsReceived.removeAll();
            
                ServiceLocator.app.root.interactiveChildren = true;

                Utils.showMessagePopup( "The room no longer exists" );

                this._state = game_state_type.IDLE;
            }
        }
        else if ( this._state == game_state_type.CHECK_INVITATION_EVENTS )
        {
            if ( Session.i.room.length > 0 )
            {
                while ( this._arrInvitationEvent.length > 0 )
                {
                    let data: LiveEventData = this._arrInvitationEvent.shift();
                    if ( !data.type )
                    {
                        const kPayload: any = JSON.parse( data.payload );
                        if ( ( kPayload.type == game_event_type.PRIVATE_ROOM_FULL
                                || kPayload.type == game_event_type.GAME_ALREADY_STARTED )
                            && kPayload.uid == Session.i.profile.uid )
                        {
                            this._checkPrivateRoomPopup.onLeave();
                            this._checkPrivateRoomPopup = null;

                            window.GameSnacks.liveMultiplayer.updatePlayerPresence( LivePresenceAction.LEAVE );
                        
                            Session.i.room = []
                            Session.i.isInvite = false;
                            Session.i.profile.uid = null;

                            ServiceLocator.multiplayerEventManager.onRoomLoaded.removeAll();
                            ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.removeAll();
                            ServiceLocator.multiplayerEventManager.onEventsReceived.removeAll();
                        
                            ServiceLocator.app.root.interactiveChildren = true;

                            this._arrInvitationEvent = [];
                            this._state = game_state_type.IDLE;

                            if ( kPayload.type == game_event_type.PRIVATE_ROOM_FULL )
                            {
                                Utils.showMessagePopup( "Room full" );
                            }
                            else
                            {
                                Utils.showMessagePopup( "The game is no longer available" );
                            }
                        }
                        else if ( kPayload.type == game_event_type.PRIVATE_ROOM_ACCESS_GRANTED ) 
                        {
                            if ( Session.i.profile.uid == kPayload.uid )
                            {
                                this._checkPrivateRoomPopup.onLeave();
                                this._checkPrivateRoomPopup = null;

                                Session.i.isInvite = false;

                                ServiceLocator.multiplayerEventManager.onRoomLoaded.removeAll();
                                ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.removeAll();
                                ServiceLocator.multiplayerEventManager.onEventsReceived.removeAll();
                            
                                console.log( "_onMultiplayer_EventsReceived :: " + Session.i.room.length );

                                let privateRoomPopup: GuestPrivateRoomPopup = new GuestPrivateRoomPopup();
                                privateRoomPopup.gameType = kPayload.gameType;
                                privateRoomPopup.onEnter();
                                privateRoomPopup.onClosed.add( this._onGuestPrivateRoomPopup_Closed, this );
                                privateRoomPopup.onGameStarted.add( this._onGuestPrivateRoomPopup_GameStarted, this );

                                ServiceLocator.app.root.interactiveChildren = true;

                                this._arrInvitationEvent = [];

                                this._state = game_state_type.IDLE;
                            }
                        }
                    }
                }
            }

            if ( this._state == game_state_type.CHECK_INVITATION_EVENTS )
            {
                this._checkPrivateRoomTimer += dt;
                if ( this._checkPrivateRoomTimer >= 6 )
                {
                    this._checkPrivateRoomPopup.onLeave();
                    this._checkPrivateRoomPopup = null;

                    Session.i.room = []
                    Session.i.isInvite = false;

                    ServiceLocator.multiplayerEventManager.onRoomLoaded.removeAll();
                    ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.removeAll();
                    ServiceLocator.multiplayerEventManager.onEventsReceived.removeAll();
                
                    ServiceLocator.app.root.interactiveChildren = true;

                    this._arrInvitationEvent = [];
                    this._state = game_state_type.IDLE;

                    Utils.showMessagePopup( "The room no longer exists" );
                }
            }
        }
    }

    // #endregion //
}

export const enum screen_type
{
    LOBBY = 0,
    FAKE_MATCH_MAKING,
    GAMEPLAY,
    SHOP
}

const enum game_state_type
{
    IDLE = 0,
    CHECK_PRIVATE_ROOM,
    CHECK_INVITATION_EVENTS
}